
define('text!app/board/templates/chatMessageTemplate.html',[],function () { return '<p><b>{{ userName }}: </b>{{ message }}</p>';});
